import React, { useState, useContext, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useQuery } from "@apollo/client";
import Select from "react-select";

import HeaderBox from "../../reuseableComponents/headerBox";
import SkeletonLoader from "../../reuseableComponents/loaders/SkeletonLoader";
import ErrorHandler from "../../reuseableComponents/ErrorHandler";
import { GET_FILE_UPLOAD_ADMIN_PAGE } from "../../../queries/archiveQrys/secureQrys/fileUploadAdminQrys";
import DocumentTypesTable from "./DocumentTypesTable";
import DocumentTypesForm from "./DocumentTypesForm";
import { UserContext } from "../../reuseableComponents/auth/UserContext";
import ButtonCreate from "../../reuseableComponents/buttons/ButtonCreate";
import FileUploadEmailNotificationsTable from "./FileUploadEmailNotificationTable";
import FileUploadEmailNotificationForm from "./FileUploadEmailNotificationForm";
import Modal from "../../reuseableComponents/ModalWindow";

const style = {
  control: (base) => ({
    ...base,
    border: "1px solid grey",
    // This line disable the blue border
    boxShadow: "none"
  }),
  placeholder: (base) => ({ ...base, color: "#595959" })
};

const FileUploadAdminPage = () => {
  const { user } = useContext(UserContext);

  const [add, setAdd] = useState(false);
  const [docTypes, setDocTypes] = useState([]);
  const [item, setItem] = useState();
  const [manage, setManage] = useState();
  const [record, setRecord] = useState();
  const [show, setShow] = useState(null);
  const [submitError, setSubmitError] = useState(null);
  // RA - I was running into an issue with apollo client always being stuck in a loading state even on success or error.
  // Found this post: https://github.com/apollographql/apollo-client/issues/9602 and implement setting state as a solution
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(null);

  const manageOptions = [
    { value: "docType", label: "Document Types" },
    { value: "assignedTo", label: "Email Notifications" }
  ];
  const { loading, error, data } = useQuery(GET_FILE_UPLOAD_ADMIN_PAGE);

  const addDocType = () => {
    if (item) {
      setItem(null);
    }
    setAdd(true);
  };

  const handleClose = () => {
    setShow(null);
  };

  const onMenuChange = (value) => {
    setManage(value.value);
  };

  useEffect(() => {
    if (data && data.getFileUploadFileTypes !== undefined) {
      setDocTypes(data.getFileUploadFileTypes);
    }
  }, [data]);

  if (loading) {
    return (
      <div className='page-container file-upload-admin-container'>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='fileUploadAdminPage' style={{ marginBottom: "0.5rem", paddingBottom: 0 }}>
              <h1 className="main-section-title">File Upload Administration</h1>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>
            <SkeletonLoader width='100%' className='m-2' />
          </Col>
        </Row>
      </div>
    );
  }
  if (error) {
    return (
      <div className='page-container file-upload-admin-container'>
        <Row>
          <Col>
            <HeaderBox id={"gray-primary"} cypressid='fileUploadAdminPage' style={{ marginBottom: "0.5rem", paddingBottom: 0 }}>
              <h1 className="main-section-title">File Upload Administration</h1>
            </HeaderBox>
          </Col>
        </Row>
        <Row>
          <Col>
            <ErrorHandler error={error} />
          </Col>
        </Row>
      </div>
    );
  }
  return (
    <div className='page-container file-upload-admin-container'>
      <Row>
        <Col>
          <HeaderBox id={"gray-primary"} cypressid='fileUploadAdminPage' style={{ marginBottom: "0.5rem", paddingBottom: 0 }}>
              <h1 className="main-section-title">File Upload Administration</h1>
          </HeaderBox>
        </Col>
      </Row>
      <Row>
        <Col>
          <label htmlFor='manage-select' className='ms-4 mb-1 fw-semibold'>
            I want to manage
          </label>
          <Select
            inputId='manage-select'
            options={manageOptions}
            onChange={onMenuChange}
            placeholder='Select an option...'
            className='m-4'
            styles={style}
            isSearchable
          />
        </Col>
      </Row>
      <Modal
        show={show}
        id='emailNotificationModal'
        handleClose={handleClose}
        modalTitle='Email Notification'
        component={FileUploadEmailNotificationForm}
        user={user}
        record={record}
        staffList={data.getAllDdwStaff}
        submitting={submitting}
        setSubmitting={setSubmitting}
      />
      {manage === "assignedTo" ? (
        <Row>
          <Col>
            <FileUploadEmailNotificationsTable
              data={data.getFileUploadDetailsAndAssignments}
              setShow={setShow}
              setRecord={setRecord}
              id='emailNotificationModal'
            />
          </Col>
        </Row>
      ) : manage === "docType" ? (
        <Row>
          <Col lg={6} md={6}>
            <h3>Document Types</h3>
            <ButtonCreate id='ddw-primary' onClick={addDocType} />
            <DocumentTypesTable data={docTypes} setItem={setItem} />
          </Col>
          <Col>
            {item || add ? (
              <DocumentTypesForm
                user={user}
                item={item}
                setItem={setItem}
                setAdd={setAdd}
                setError={setSubmitError}
                setSuccess={setSuccess}
                submitError={submitError}
                submitting={submitting}
                setSubmitting={setSubmitting}
              />
            ) : (
              ""
            )}
            <span className='error' role="alert">{submitError}</span>
            <span className='success'>{success}</span>
          </Col>
        </Row>
      ) : (
        ""
      )}
    </div>
  );
};

export default FileUploadAdminPage;
